import { BalanceQuoterABI } from '../components/abi/BalanceQuoterABI';
import { useReadContract } from 'wagmi';
import { CHAINS } from '@dapp/multi-lib/network';
import { QueryOptions } from 'utils/useQueryUtils';

const quoterAddress = '0x9B96CB4F5Dbf666E7B799cbCa07a362180952c36';

export interface AssetsDataQuoted {
  map: Record<`0x${string}`, { balance: bigint; quote: bigint }>;
  balances: readonly bigint[];
  quotes: readonly bigint[];
  quotesTotal: bigint;
}

export const useUserAssetsQuoted = (
  params: {
    userAddress: `0x${string}`;
    quoteAddress: `0x${string}`;
    tokenAddresses: `0x${string}`[];
  } & QueryOptions
) => {
  const { userAddress, quoteAddress, tokenAddresses, query = {} } = params;

  const queryOptions = {
    refetchInterval: 15000,
    staleTime: 15000,
    ...query,
    enabled:
      query.enabled &&
      !!userAddress &&
      !!quoteAddress &&
      tokenAddresses.length > 0,
  };

  return useReadContract({
    abi: BalanceQuoterABI,
    address: quoterAddress,
    functionName: 'quoteBalancesFor',
    chainId: CHAINS.BASE_L2,
    args: [userAddress, quoteAddress, tokenAddresses],
    query: {
      ...queryOptions,
      select: (data): AssetsDataQuoted => {
        return {
          map: tokenAddresses.reduce(
            (acc, address, index) => {
              acc[address] = {
                balance: data[0][index],
                quote: data[1][index],
              };
              return acc;
            },
            {} as Record<string, { balance: bigint; quote: bigint }>
          ),
          balances: data[0],
          quotes: data[1],
          quotesTotal: data[1].reduce((acc, item) => acc + item, BigInt(0)),
        };
      },
    },
  });
};
